import axios from "axios";
import { tokenStore } from "@/lib/api";

// Local backend (marketplace features). Uses the same login token, validated
// server-side against the external shop backend.
const LOCAL_BASE = process.env.REACT_APP_BACKEND_URL;

const localApi = axios.create({ baseURL: `${LOCAL_BASE}/api` });

localApi.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default localApi;
